import { Component, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { NbDialogRef, NbDialogService, NbToastrService } from '@nebular/theme';
import { PasswordValidator } from '../../../../directives/validator.password';
import { AuthService, UserInfo } from '../../../../providers/auth.provider';
import { CONST } from '../../../../providers/const';
import { CustomValidators } from '../../../../providers/custom-validators';
import { UtilitiesService } from '../../../../providers/utilities.provider';
import { PopoverHelpPasswordComponent } from '../../popovers/help-password/help-password-popover.component';


/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}


@Component({
  selector: 'ngx-change-password-dialog',
  templateUrl: 'change-password-dialog.component.html',
  styleUrls: ['change-password-dialog.component.scss'],
})
export class ChangePasswordDialogComponent {

  form: FormGroup;
  hide = false;
  isLoading = false;
  matcher = new MyErrorStateMatcher();
  passwordComponent = PopoverHelpPasswordComponent;

  constructor(
    protected ref: NbDialogRef<ChangePasswordDialogComponent>,
    private formBuilder: FormBuilder,
    private service: AuthService,
    private nbDialog: NbDialogService,
    private nbToastr: NbToastrService
  ) {

  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      currentPassword: [null, [Validators.required, Validators.minLength(8), Validators.maxLength(72)]],
      password: [null, [Validators.required, Validators.minLength(8), Validators.maxLength(72), PasswordValidator.strong]],
      confirmPassword: [null, [Validators.required, Validators.minLength(8), Validators.maxLength(72)]],
    },
      {
        validators: [
          CustomValidators.passwordMatchValidator,
        ]
      }
    );

  }

  dismiss() {
    this.ref.close();
  }

  changePassword() {
    UtilitiesService.showConfirmDialog(this.nbDialog, "Change Password", null, "Do you want to change the password?", "Yes", "Cancel")
      .then(questionRes => {
        if (questionRes) {
          let value = this.form.value;
          this.isLoading = true;
          let body: any = {
            oldPassword: value.currentPassword,
            password: value.password,
            passwordConfirm: value.confirmPassword
          };

          this.service.changePassword(body).toPromise()
            .finally(() => this.isLoading = false)
            .then(res => {
              this.dismiss();
              UtilitiesService.showToastSuccess(this.nbToastr, "Change Password", "Password updated");
            })
        }
      })



  }
}
